import React from "react";

const Send = () => {
  return (
    <path d="M15.8362042,16.1639389 L27.5240985,4.47619949 L6.52636636,11.8126593 L15.8362042,16.1639389 Z M0.919301423,10.3398202 L30.2972622,0.0753674362 C30.9881361,-0.166019069 31.723642,0.191607511 31.9400603,0.874148668 C32.0248472,1.14154979 32.0195587,1.43241035 31.9249888,1.70307253 L21.6604001,31.0806441 C21.4190104,31.7715089 20.670009,32.1561261 19.9874588,31.9397106 C19.6532905,31.8337562 19.3812231,31.5953462 19.2332879,31.2788376 L13.3368149,18.6632951 L0.721105195,12.7669002 C0.0746173146,12.4647414 -0.185287451,11.6864615 0.140591561,11.0285634 C0.30013807,10.7064644 0.581057782,10.4580002 0.919301423,10.3398202 Z" />
  );
};

export default Send;
